import { htmlToElement } from "./utils";
import { elementScrollIntoView } from "seamless-scroll-polyfill";

export class ReviewLinesLimiter {
    constructor(element, options) {
        this.element = element;
        this.heightLimiter = 5;

        this._setDefaults(options);

        this.isOpen = new Proxy(this.isOpen, {
            set(target, name, val) {
                target[name] = val;
                return true;
            },
        });

        this.isOpen.state = false;
        this._init();
    }

    _setDefaults(options) {
        const defaults = {
            isOpen: {
                state: false,
            },
            statusText: {
                initial: "Читать отзыв полностью",
                opened: "Свернуть",
            },
            template(buttonOptions) {
                return `
                    <span class="lines-limiter-button" >
                        <span class="lines-limiter-button__span">${buttonOptions.statusText}</span>
                    </span>`;
            },
        };
        Object.assign(this, defaults, options);
    }

    _init() {
        const elementsToLimitClamps = this.element.querySelectorAll("[data-line-limiter]");

        for (let i = 0; i < elementsToLimitClamps.length; i++) {
            const element = elementsToLimitClamps[i];
            const elementLinesCount = element.offsetHeight / 22;

            if (this.heightLimiter === 0) {
                this._hideParent(element);
                this._addButton();
            }

            if (this.heightLimiter > 0) {
                if (elementLinesCount >= 5) {
                    this._cutElement(element);
                    this.heightLimiter = 0;
                    this._addButton();
                }

                if (elementLinesCount < 5) {
                    if (this.heightLimiter - elementLinesCount >= 0) {
                        this.heightLimiter -= elementLinesCount;
                    } else {
                        this._cutElement(element);
                        this.heightLimiter = 0;
                        this._addButton();
                    }
                }
            }
        }
    }

    _reInit() {
        const targets = this.element.querySelectorAll("[data-line-limiter]");

        for (let i = 0; i < targets.length; i++) {
            const target = targets[i];

            if (target.dataset.cutterLimit) {
                this._cutElement(target, target.dataset.cutterLimit);
            }

            if (target.dataset.hide === "true") {
                this._hideParent(target);
            }
        }
    }

    _hideParent(target) {
        target.parentNode.classList.add("hidden");
        target.dataset.hide = "true";
    }

    _unhideParent() {
        const targets = this.element.querySelectorAll("[data-line-limiter]");

        for (let i = 0; i < targets.length; i++) {
            const target = targets[i];

            target.parentNode.classList.remove("hidden");
        }
    }

    _cutElement(target, value) {
        const limiter = value || this.heightLimiter;

        target.classList.add("cutted");
        target.style.setProperty("--line-clamp-count", limiter);
        target.dataset.cutterLimit = `${limiter}`;
    }

    _unCutElement() {
        const targets = this.element.querySelectorAll("[data-line-limiter]");

        for (let i = 0; i < targets.length; i++) {
            const target = targets[i];

            target.classList.remove("cutted");
            target.style.removeProperty("--line-clamp-count");
        }
    }

    _addButton() {
        if (this.hasButton) return;

        this.button = htmlToElement(
            this.template({
                statusText: this.statusText.initial,
            }),
        );

        this.element.appendChild(this.button);

        this.buttonTextContainer = this.button.querySelector(".lines-limiter-button__span");

        this.button.addEventListener("click", (event) => {
            event.stopPropagation();

            if (this.isOpen.state) {
                elementScrollIntoView(this.element, {
                    behavior: "smooth",
                    block: "center",
                });
                this._reInit();
                this._toggleButtonClass();

                this.buttonTextContainer.innerHTML = this.statusText.initial;
                this.isOpen.state = false;
            } else {
                this._unCutElement();
                this._unhideParent();
                this._toggleButtonClass();

                this.buttonTextContainer.innerHTML = this.statusText.opened;
                this.isOpen.state = true;
            }
        });

        this.hasButton = true;
    }

    _toggleButtonClass() {
        this.button.classList.toggle("active");
    }
}
